import React from 'react';
import Box from '@mui/material/Box';
import {Typography} from '@mui/material';
import Link from '@mui/material/Link';
import Button from '@mui/material/Button';
import Chart from './Chart';

const styles = {
    wrapper: {
        mt: {xs: 3, lg: '117px'},
        mx: {xs: 3, md: 'auto'},
        maxWidth: '794px',
    },
    title: {
        fontSize: {xs: 36, lg: 54},
        fontStyle: 'italic',
        mb: 4,
    },
    link: {
        color: 'primary.dark',
        textDecoration: 'none',
    },
    note: {
        fontSize: 12,
        mt: 2,
    },
    estimateBtn: {
        mt: {xs: 5, lg: 8},
        minHeight: 78,
        borderRadius: '100px',
        fontFamily: 'FredokaMedium',
        fontSize: '18px !important',
    },
};

const Info: React.FC = () => {
    return (
        <Box mt={{xs: 5, md: 14}}>
            <Box sx={styles.wrapper}>
                <Typography component="h2" variant="h2" sx={styles.title}>
                    What is Indexed Universal Life (IUL) Insurance?
                </Typography>
                <Typography mt={{xl: 4}} variant="body2">
                    A type of{' '}
                    <Link
                        href="https://www.getamplifylife.com/learn/glossary#p%20section"
                        target="_blank"
                        sx={styles.link}
                    >
                        Permanent Life Insurance
                    </Link>{' '}
                    that provides coverage for the entire lifetime* of the insured, as long as the policy is in force
                    and premiums are paid. It is similar to{' '}
                    <Link
                        href="https://www.getamplifylife.com/learn/glossary#g%20section"
                        target="_blank"
                        sx={styles.link}
                    >
                        Guaranteed Universal Life Insurance
                    </Link>{' '}
                    in that it also provides a{' '}
                    <Link
                        href="https://www.getamplifylife.com/learn/glossary#d%20section"
                        target="_blank"
                        sx={styles.link}
                    >
                        death benefit
                    </Link>{' '}
                    to the beneficiaries of the policy and also accumulates{' '}
                    <Link
                        href="https://www.getamplifylife.com/learn/glossary#c%20section"
                        target="_blank"
                        sx={styles.link}
                    >
                        cash value
                    </Link>{' '}
                    over time. Rather than earning a fixed interest rate the cash value of an IUL policy is tied to a
                    stock market index, such as the S&P 500. Usually, the cash value of the policy will increase when
                    the stock market index increases, but will not decrease when the stock market index decreases. This
                    means that the cash value of the policy has the potential to increase (up to a cap stated in the
                    policy) at a faster rate than Guaranteed or Fixed Universal Life Insurance. IUL policies also have a
                    minimum guaranteed interest rate, which means that the cash value will not decrease below a certain
                    level.
                </Typography>
                <Typography mt={2} variant="body2">
                    Visit our{' '}
                    <Link href="https://getamplifylife.com/product/iul" target="_blank" sx={styles.link}>
                        IUL product page
                    </Link>{' '}
                    to learn more.
                </Typography>
                <Typography variant="subtitle2" sx={styles.note}>
                    *Policies typically mature, meaning they pay out the benefit amount, if the policyholder lives to be
                    120 or 121 years old (could be shorter, depending on the policy).
                </Typography>
            </Box>

            <Chart />

            <Box sx={{...styles.wrapper, mb: {md: 12.5}}}>
                <Typography component="h2" variant="h2" sx={styles.title}>
                    When can I access my funds?
                </Typography>
                <Typography variant="body2">
                    There is no age restriction or use-case restriction on when you can access your cash value.
                    Typically, you should be able to have limited access to the cash value account after year 2 or 3,
                    but will not be able to access all of the cash inside your account without facing a surrender charge
                    until after year 10-15. Surrender charge rules vary by carrier, and are used to ensure the carrier
                    has enough time to recoup their costs for setting up and managing the policy.
                </Typography>

                <Button
                    variant="contained"
                    fullWidth
                    sx={styles.estimateBtn}
                    onClick={() => {
                        if (window.scrollY > 0) {
                            window.scrollTo({top: 0, behavior: 'smooth'});
                        }
                        return false;
                    }}
                >
                    Get an Estimate
                </Button>
            </Box>
        </Box>
    );
};

export default Info;
